import { graphqlClient } from '@topconagriculture/graphql-client';
import { API_CLIENTS } from '../../config/constants';
import { VEHICLE_STATUS_GQL, VEHICLES_LIST_GQL } from './gql';
import { mapVehicleDtoVehicle } from './vehicle.mapper';
import { mapPaginatedResponse, flattenPaginatedNodes } from '../../api/api.utils';
export const getVehicleStatusQuery = async () => {
    return graphqlClient
        .getClient(API_CLIENTS.graphqlClient)
        .query({
        query: VEHICLE_STATUS_GQL,
        fetchPolicy: 'network-only',
        variables: {},
    })
        .then((response) => {
        return response.data.vehicleLastKnownStatuses;
    });
};
export const getVehiclesList = async () => {
    const response = await graphqlClient.getClient(API_CLIENTS.graphqlClient).query({
        query: VEHICLES_LIST_GQL,
        fetchPolicy: 'network-only',
        variables: {
            first: -1,
        },
    });
    const pages = mapPaginatedResponse(response.data.vehicles, mapVehicleDtoVehicle);
    const flattenPages = flattenPaginatedNodes(pages);
    return flattenPages.nodes.filter((x) => !!x.gps && !!x.gps.position);
};
//# sourceMappingURL=vehicle.query.js.map